import * as React from 'react';
export const vaultSvg = React.forwardRef(function vaultSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm2.386-4.75H10a.75.75 0 0 0 0 1.5h1.386a2.501 2.501 0 1 1 0-1.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 11.5v1A2.5 2.5 0 0 0 3.5 15h.543a.749.749 0 0 0 .707 1h1.5a.75.75 0 0 0 .707-1h3.086a.75.75 0 0 0 .707 1h1.5a.75.75 0 0 0 .707-1h.543a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 13.5 1h-10A2.5 2.5 0 0 0 1 3.5v1H.75a.75.75 0 0 0 0 1.5H1v4H.75a.75.75 0 0 0 0 1.5H1Zm12.5-9h-10a1 1 0 0 0-1 1v1h1.25a.75.75 0 0 1 0 1.5H2.5v4h1.25a.75.75 0 0 1 0 1.5H2.5v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1Z',
    }),
  );
});
vaultSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vault = {
  category: 'icon',
  colorable: true,
  name: 'vault',
  svg: vaultSvg,
};
